import styled from 'styled-components';

export default styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;


  ${props => props.onClick ? 'cursor: pointer;' : ''}
  ${props => props.$thisStylesWrapper}

  & svg, & svg path, & svg circle {
    height: 100%;
    width: 100%;
    max-height: 1.6rem;
    max-width: 1.6rem;
    
    ${props => props.$iconStyles}
  }
  
  [class$="_svg__cls-1"] {
    ${props => props.$iconStyles}
  }

  &:hover {

    & svg, & svg path, & svg circle {
      ${props => props.$iconStylesHover}
    }

    [class$="_svg__cls-1"] {
      ${props => props.$iconStylesHover}
    }

    ${props => props.$thisStylesHover}

  }

`;
